import classNames from 'classnames';
import React, { FCC } from 'react';
import { IImageProps } from './types';

export const Image: FCC<IImageProps> = (props) => {
  const { src, alt, shape = 'sharp', responsive = true, align, height, width, maxHeight, maxWidth } = props;

  const classes = classNames({
    'center-block': align === 'center',
    'img-circle': shape === 'circle',
    'img-responsive': responsive,
    'img-rounded': shape === 'rounded',
    'img-thumbnail': shape === 'thumbnail',
    'pull-left': align === 'left',
    'pull-right': align === 'right',
  });

  return (
    <img
      style={{ maxHeight, maxWidth }}
      src={src}
      className={classes}
      alt={alt}
      qa-id={props['qa-id']}
      height={height}
      width={width}
      title={alt}
    />
  );
};

export default Image;
